import { Mail, MessageSquare, Twitter, Clock } from "lucide-react";
import SEO from "@/components/SEO";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-zinc-300">
      <SEO title="Contact — SourceDeck" description="Get in touch with the SourceDeck team. We reply within 24 hours." path="/contact" />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <a href="/" className="sd-label mb-8 inline-block hover:text-white transition-colors" data-testid="legal-back-home">← BACK TO SOURCEDECK</a>
        <div className="sd-label mb-3 text-[#FF3B30]">● SUPPORT</div>
        <h1 className="font-display text-5xl md:text-6xl leading-tight tracking-tight mb-4">Get in touch</h1>
        <p className="text-zinc-400 mb-12 text-lg leading-relaxed max-w-xl">
          We reply to every email — usually within 24 hours on business days, faster during launch weeks.
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-12">
          <a
            href="mailto:hello@sourcedeck.tech"
            className="sd-card p-6 flex items-start gap-4 group hover:border-[#FF3B30] transition-colors"
            data-testid="contact-email-card"
          >
            <div className="w-10 h-10 border border-[#27272a] bg-[#141414] flex items-center justify-center shrink-0 group-hover:bg-[#FF3B30]/20 group-hover:border-[#FF3B30] transition-colors">
              <Mail size={16} strokeWidth={1.5} className="text-[#FF3B30]" />
            </div>
            <div className="min-w-0">
              <div className="sd-label mb-1">SUPPORT · BILLING · FEEDBACK</div>
              <div className="font-display text-xl mb-2">Email us</div>
              <div className="text-sm text-zinc-400 font-mono truncate">hello@sourcedeck.tech</div>
            </div>
          </a>

          <div className="sd-card p-6 flex items-start gap-4" data-testid="contact-hours-card">
            <div className="w-10 h-10 border border-[#27272a] bg-[#141414] flex items-center justify-center shrink-0">
              <Clock size={16} strokeWidth={1.5} className="text-[#FF3B30]" />
            </div>
            <div className="min-w-0">
              <div className="sd-label mb-1">RESPONSE TIME</div>
              <div className="font-display text-xl mb-2">Fast &amp; human</div>
              <div className="text-sm text-zinc-400">
                Mon–Fri: within 12 hrs<br />
                Weekends: within 48 hrs
              </div>
            </div>
          </div>
        </div>

        <div className="sd-card p-8">
          <div className="sd-label mb-4">BUSINESS DETAILS</div>
          <div className="space-y-3 text-sm">
            <div className="grid grid-cols-[140px_1fr] gap-2">
              <div className="font-mono text-xs text-zinc-500">OPERATOR</div>
              <div>SourceDeck (individual creator platform)</div>
            </div>
            <div className="grid grid-cols-[140px_1fr] gap-2">
              <div className="font-mono text-xs text-zinc-500">COUNTRY</div>
              <div>India</div>
            </div>
            <div className="grid grid-cols-[140px_1fr] gap-2">
              <div className="font-mono text-xs text-zinc-500">SUPPORT EMAIL</div>
              <div>hello@sourcedeck.tech</div>
            </div>
            <div className="grid grid-cols-[140px_1fr] gap-2">
              <div className="font-mono text-xs text-zinc-500">BILLING</div>
              <div>Powered by Razorpay · INR</div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-xs font-mono text-zinc-600 text-center">
          Also see: <a href="/terms" className="hover:text-white transition-colors">Terms</a> · <a href="/privacy" className="hover:text-white transition-colors">Privacy</a> · <a href="/refund" className="hover:text-white transition-colors">Refund Policy</a>
        </div>
      </div>
    </div>
  );
}
